import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { EntityManager } from "@/components/EntityManager";
import { StatementImporter } from "@/components/StatementImporter";
import { ENTITY_CONFIG } from "@/lib/entities";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { GitCompareArrows, Plus } from "lucide-react";

export default function Banks() {
  const [refreshKey, setRefreshKey] = useState(0);
  const [accounts, setAccounts] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    api
      .get("/entities/bank-accounts")
      .then(({ data }) => setAccounts(data || []))
      .catch(() => {});
  }, [refreshKey]);

  return (
    <div className="space-y-6">
      <EntityManager key={refreshKey} config={ENTITY_CONFIG.banks} />

      <Card className="p-4 space-y-3" data-testid="bank-txn-shortcuts">
        <div className="flex flex-wrap items-center justify-between gap-2">
          <div>
            <p className="text-sm font-medium">Bank transactions</p>
            <p className="text-xs text-muted-foreground">
              Add, edit or delete individual bank lines and match them to invoices.
            </p>
          </div>
          <Button
            variant="outline"
            size="sm"
            onClick={() => navigate("/recon")}
            className="gap-2"
            data-testid="banks-open-recon"
          >
            <GitCompareArrows className="h-4 w-4" />
            Open reconciliation
          </Button>
        </div>
        {accounts.length > 0 && (
          <div className="flex flex-wrap gap-1.5">
            {accounts.map((a) => (
              <button
                key={a.id}
                onClick={() => navigate(`/recon?account_id=${a.id}`)}
                data-testid={`banks-txn-link-${a.id}`}
                className="inline-flex items-center gap-1.5 text-xs px-2.5 py-1.5 rounded-md border border-white/5 text-muted-foreground hover:text-foreground hover:bg-white/[0.04] transition-colors"
              >
                <Plus className="h-3 w-3" />
                {a.name}
              </button>
            ))}
          </div>
        )}
      </Card>

      <StatementImporter onPosted={() => setRefreshKey((k) => k + 1)} />
    </div>
  );
}
